import { FC, useCallback, useContext } from 'react';
import Link from 'next/link';
import IconButton from '@mui/material/IconButton';

import useLocalised from 'customHooks/useLocalised/useLocalised';
import {
  navigationPaths,
  MOBILE_PARTNER_MENU_DIALOGUE,
  colorConstants,
  membershipCategoryOptions,
} from 'data/constants';
import { about, membership, our_hotels } from 'data/translationKeys';
import NavigationItem from 'components/NavigationItem/NavigationItem';
import LittleEmperorsIcon from 'components/icons/LittleEmperorsIcon';
import { DialogueContext } from 'customHooks/useDialogue/useDialogue';
import BurgerMenuIcon from 'components/icons/BurgerMenuIcon';
import LittleEmperorsTextIcon from 'components/icons/LittleEmperorsTextIcon';
import { JoinUsContext } from 'customHooks/useJoinUs/useJoinUs';

interface IHeader {}
export const PartnerHeader: FC<IHeader> = () => {
  const about_text = useLocalised(about);
  const membership_text = useLocalised(membership);
  const our_hotels_text = useLocalised(our_hotels);
  const { openDialogue } = useContext(DialogueContext);

  const handleBurgerMenuClick = useCallback(() => {
    openDialogue(MOBILE_PARTNER_MENU_DIALOGUE);
  }, [openDialogue]);

  const { joinUsState: state, setState } = useContext(JoinUsContext);

  return (
    <div className="header-component">
      <div className="header-component__container">
        <div className="header-left">
          <NavigationItem
            title={about_text}
            path={navigationPaths.HOMEPAGE}
            className="header-navigation-item"
          />
          <Link className="navigation-item" href={navigationPaths.MEMBERSHIP}>
            <a
              className="header-navigation-item"
              area-label={membership_text}
              onClick={() => {
                setState(state => ({
                  ...state,
                  memberShipCategory: membershipCategoryOptions.LEISURE,
                }));
              }}
            >
              {membership_text}
            </a>
          </Link>
          <NavigationItem
            title={our_hotels_text}
            path={navigationPaths.OUR_HOTELS}
            className="header-navigation-item"
          />
        </div>
        <div className="burger-icon">
          <IconButton onClick={handleBurgerMenuClick} title="mobile-menu">
            <BurgerMenuIcon />
          </IconButton>
        </div>
        <div className="header-center">
          <Link href={navigationPaths.HOMEPAGE}>
            <a area-label="homepage">
              <LittleEmperorsIcon color={colorConstants.brandColor} />
            </a>
          </Link>
          <Link href={navigationPaths.HOMEPAGE}>
            <a area-label="homepage">
              <LittleEmperorsTextIcon color={colorConstants.brandColor} />
            </a>
          </Link>
        </div>
        <div className="header-rigth"></div>
      </div>
    </div>
  );
};

export default PartnerHeader;
